<template>
  <div class="sample-page analysis-jobs-body">
    <div class="breadcrumb">
      <a-breadcrumb>
        <a-breadcrumb-item>
          <router-link to="/">Home</router-link>
        </a-breadcrumb-item>
        <a-breadcrumb-item><router-link to="/analysis">Run Jobs</router-link></a-breadcrumb-item>
        <a-breadcrumb-item>Details</a-breadcrumb-item>
      </a-breadcrumb>
    </div>
    <div class="analysis-jobs-details">
      <a-row class="analysis-jd-info">
        <a-col :span="24" class="title">pipeline：{{ jobsInfo.pipelineName || "- -" }}</a-col>
        <a-col :span="24" class="jobs-name">{{
          jobsInfo.jobName || "- -"
        }}</a-col>
      </a-row>
      <a-row class="analysis-jd-info border-bottom">
        <a-col :span="24" class="title">
          <div class="fl">Running log：</div>
          <div class="fl wordbreak">
            {{ logData }}
          </div>
        </a-col>
      </a-row>
      <a-row type="flex" class="analysis-jd-info">
        <a-col :flex="flex" class="title t-right">Results：</a-col>
      </a-row>
      <a-row type="flex" class="analysis-jd-info">
        <a-col :flex="flex1" class="title t-right title-color">AL Model</a-col>
        <a-col flex="auto">
          <a-row>
            <a-col :span="10">
              <a-row class="analysis-tab-data" v-for="(value, key) in alTabData">
                <a-col :span="6"> {{ key }} </a-col>
                <a-col :span="14">{{ value }}</a-col>
                <a-col :span="4"></a-col>
              </a-row>
            </a-col>
            <a-col :span="14"><iframe :src="alData" scrolling="no" frameborder="0" width="100%"
                :height="iframeHeight"></iframe></a-col>
          </a-row>
        </a-col>
      </a-row>
      <a-row type="flex" class="analysis-jd-info"
        v-if="alTabData['PredSubtype'] && alTabData['PredSubtype'].indexOf('BALL') != -1">
        <a-col :flex="flex1" class="title t-right title-color">BALL Model</a-col>
        <a-col flex="auto">
          <a-row>
            <a-col :span="10">
              <a-row class="analysis-tab-data" v-for="(value, key) in ballTabData">
                <a-col :span="6"> {{ key }} </a-col>
                <a-col :span="14">{{ value }}</a-col>
                <a-col :span="4"></a-col>
              </a-row>
            </a-col>
            <a-col :span="14">
              <iframe :src="ballData" scrolling="no" frameborder="0" width="100%"
                :height="iframeHeight"></iframe></a-col>
          </a-row>
        </a-col>
      </a-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      flex: "120px",
      flex1: "110px",
      logData: "",
      alData: "",
      ballData: "",
      alTabData: "",
      ballTabData: "",
      jobsId: "",
      jobsInfo: {},
      iframeHeight: 500,
    };
  },
  mounted() {
    this.jobsId = this.$route.query.jobsId;
    this.emitRdFile();
    this.getJobsStatus();
  },
  methods: {
    emitRdFile() {
      let $this = this;
      this.getRdFile("log.iwandresultfiles.txt", (res) => {
        $this.logData = res;
      });
      this.getRdFile("polar_al_iwandresultfiles.html", (res) => {
        $this.alData = res;
      });
      this.getRdFile("polar_ball_iwandresultfiles.html", (res) => {
        $this.ballData = res;
      });
      this.getRdFile("pydf_al_iwandresultfiles.tab", (res) => {
        if (res) {
          $this.alTabData = JSON.parse(res);
        }
      });
      this.getRdFile("pydf_ball_iwandresultfiles.tab", (res) => {
        if (res) {
          $this.ballTabData = JSON.parse(res);
        }
      });
    },
    getRdFile(filename, cb) {
      this.$get("open/ps/job/rd", {
        saasJobId: this.jobsId,
        filename: filename,
      }).then((res) => {
        if (res.data.code == 1) {
          cb(res.data.data);
        }
      });
    },
    getJobsStatus() {
      let $this = this;
      if (this.jobsId == "run-example") {
        this.jobsInfo = {
          jobName: "predRnnVer1-run-example",
          pipelineName: "predRnnVer1",
        };
      } else {
        this.$get("open/ps/job/status", {
          saasJobId: this.jobsId,
        }).then((res) => {
          if (res.data.code == 1) {
            this.jobsInfo = JSON.parse(res.data.data);
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.analysis-jobs-body {
  padding-bottom: 0;

  .analysis-tab-data {
    margin: 0 15px;
    line-height: 28px;
    color: #1f1f1f;

    /deep/ .ant-col {
      padding: 2px 15px;
    }

    &:nth-child(odd) {
      background-color: #f9fbfb;
    }
  }

  iframe {
    border: 0;
    background-color: transparent;
    transform: scale(0.7, 0.7) translate(-20%, -20%);
  }

  .analysis-jobs-details {
    background: #fff;
    padding-bottom: 40px;
  }

  .analysis-jd-info {
    padding: 16px 40px 14px 40px;
    line-height: 26px;

    &.border-bottom {
      border-bottom: 1px dashed #979797;
    }

    .jobs-name {
      font-size: 18px;
      font-weight: 600;
      color: #162232;
      line-height: 26px;
    }

    .title {
      font-size: 16px;
      color: #9b9b9b;
      padding-right: 10px;
    }

    .t-right {
      text-align: right;
    }

    .title-color {
      color: #1f1f1f;
    }

    .wordbreak {
      word-break: break-all;
      width: 900px;
    }
  }
}
</style>